export type ScrubbingRule = {
  id?: number;
  name: string;
  logFilter: string;
  matchText: string;
  replaceWith: string;
  position?: number;
};

export enum ScrubbingRuleFormVariant {
  ADD = 'add',
  UPDATE = 'update',
}

export type ScrubbingRuleFormData = {
  variant: ScrubbingRuleFormVariant;
  values: ScrubbingRule;
};
